module.exports = __webpack_public_path__ + "79adf8e2867b68130d31d44413b0ef29.svg";